/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxmUserauthV1OrganizationMemberInvitationEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXM_USERAUTH_V1_ORGANIZATION_MEMBER_INVITATION_EVENT_ENTITY_NAME = 'ixm.userauth.v1.OrganizationMemberInvitationEvent';
export const ixmUserauthV1OrganizationMemberInvitationEventEntity = new schema.Entity<IxmUserauthV1OrganizationMemberInvitationEvent>(IXM_USERAUTH_V1_ORGANIZATION_MEMBER_INVITATION_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxmUserauthV1OrganizationMemberInvitationEvent) => `${entity.metadata?.eventId}` });

